import React from 'react';
import { ReactComponent as BankIdentLogo } from '../../../assets/images/BankIdentLogoNoText.svg';
import { useAppTranslation } from '../../../i18n';
import { useAppDispatch } from '../../../app/hooks';
import { changeStep } from '../../../app/slices/step.slice';
import IdentificationMethodCard from './IdentificationMethodCard';

const TRANSLATION_PREFIX = 'steps.bank-auth-type-selection';

const BankIdent = () => {
	const { t } = useAppTranslation();
	const dispatch = useAppDispatch();

	const handleSubmit = () => {
		dispatch(changeStep('BANK_STEP'));
	};

	return (
		<IdentificationMethodCard
			id="bank-ident-auth"
			icon={<BankIdentLogo className="w-11 h-11" />}
			title={t(`${TRANSLATION_PREFIX}.bank-ident-title`)}
			description={t(`${TRANSLATION_PREFIX}.bank-ident-description`)}
			trustText={t(`${TRANSLATION_PREFIX}.bank-ident-trust`)}
			onClick={handleSubmit}
		/>
	);
};

export default BankIdent;
